import { getTicketCountOfTicketLines } from '../../utils/tickets/order-ticket-line-utils';
import { getOrderTicketsForShowtime } from './get-order-tickets-for-showtime';
export const getOrderTicketCountForShowtime = (showtimeId) => {
    return getTicketCountOfTicketLines(getOrderTicketsForShowtime(showtimeId));
};
